import { API } from '@/config';
import type { IssueListQuery, PanelIssue, RaiseIssueRequest, UpdateIssueRequest } from '@/types';
import { api } from './client';
import { getPaginated, type Paginated } from './paginated';

/**
 * Issues raised against the portals themselves.
 *
 * Note what is NOT sent when raising one: the reporter. The server takes that
 * from the token, because an issue attributed to whoever the client claims is
 * not an audit trail.
 */
export const issuesService = {
  list: (query: IssueListQuery, signal?: AbortSignal): Promise<Paginated<PanelIssue>> =>
    getPaginated<PanelIssue>(API.endpoints.issues, query, signal, 'Could not load issues.'),

  raise: (body: RaiseIssueRequest): Promise<PanelIssue> =>
    api.post<PanelIssue>(API.endpoints.issues, body),

  /**
   * Moving status to `resolved` stamps `resolvedAt` server-side, so the
   * timeline cannot be backdated from here.
   */
  update: (issueId: string, body: UpdateIssueRequest): Promise<PanelIssue> =>
    api.patch<PanelIssue>(API.endpoints.issue(issueId), body),
};
